// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-comment-form .text-area-with-mentions textarea {
    border-radius: 10px;
    padding: 10px;
    width: 100%;
    height: 90px;
    box-sizing: border-box;
    resize: none;
}
.post-comment-form .buttons {
    text-align: right;
    font-size: 12px;
}
.post-comment-form .error {
    text-align: center;
    color: var(--danger-color-main);
}

a.create-comment {
    display: block;
    margin: 5px auto;
    font-size: 14px;
    border-radius: 10px;
    padding: 10px;
}

a.create-comment:link,
a.create-comment:visited,
a.create-comment:active {
    color: var(--primary-color-dark);
    background-color: var(--primary-color-lightest);
}
a.create-comment:hover {
    color: var(--primary-color-darkest);
    background-color: white;
}
`, "",{"version":3,"sources":["webpack://./client/components/posts/PostCommentForm/PostCommentForm.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;;IAGI,gCAAgC;IAChC,+CAA+C;AACnD;AACA;IACI,mCAAmC;IACnC,uBAAuB;AAC3B","sourcesContent":[".post-comment-form .text-area-with-mentions textarea {\n    border-radius: 10px;\n    padding: 10px;\n    width: 100%;\n    height: 90px;\n    box-sizing: border-box;\n    resize: none;\n}\n.post-comment-form .buttons {\n    text-align: right;\n    font-size: 12px;\n}\n.post-comment-form .error {\n    text-align: center;\n    color: var(--danger-color-main);\n}\n\na.create-comment {\n    display: block;\n    margin: 5px auto;\n    font-size: 14px;\n    border-radius: 10px;\n    padding: 10px;\n}\n\na.create-comment:link,\na.create-comment:visited,\na.create-comment:active {\n    color: var(--primary-color-dark);\n    background-color: var(--primary-color-lightest);\n}\na.create-comment:hover {\n    color: var(--primary-color-darkest);\n    background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
